// ScheduleColumn.js
import React, { useState, useEffect, useRef } from 'react';
import './MatchSchedule.css';
import TextField from '@mui/material/TextField';
import CloseIcon from '@mui/icons-material/Close';
import { useDrag, useDrop } from 'react-dnd';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import Chip from '@mui/material/Chip';
import { CalendarIcon } from '@mui/x-date-pickers';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import { ExpandLess, ExpandMore, Label } from '@mui/icons-material';
import { faEye, faFileLines } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DropZone from './DropZone';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import { faClock, faCalendarCheck, faHourglassStart, faClipboard, faPause, faStickyNote, faPauseCircle, faPlay, faTrash, faTrashRestore } from '@fortawesome/free-solid-svg-icons';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { EventNote } from '@mui/icons-material';
import ScheduleColumnSummary from './ScheduleColumnSummary';
import { useNavigate } from 'react-router-dom';
import { Icon } from '@mui/material';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import DynamicForm from '../DynamicForm';
import JSONTableEditor from '../JSONTableEditor';
import CentralCalls from '../../centralCalls';
import { faBan } from '@fortawesome/free-solid-svg-icons';
import { faExplosion } from '@fortawesome/free-solid-svg-icons';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button, IconButton, Tooltip, MenuItem, Select } from '@mui/material';
import PostFinishJobAutomation from '../phase/PostFinishJobAutomation';
import FinishTaskDialog from '../phase/FinishTaskDialog';
import WipPhaseFilesDialog from '../workInProgress/WipPhaseFilesDialog';
import { Auth } from 'aws-amplify';
const ItemTypes = {
    JOB: 'JOB',
    CREW_LIST: 'CREW_LIST',
};

function DroppableJob({ job, index, date, crewColors, moveJob, assignCrewToJob, unassignCrewFromJob, refreshMenu, setRefresh, isPastDue }) {
    const ref = useRef(null);
    //const [PhaseOid, setPhaseOid] = useState(null);
    //const [LotOid, setLotOid] = useState(null);
    // const [phaseType, setPhaseType] = useState('');

    const [refreshUndergroundKey, setRefreshUndergroundKey] = useState(0);
    const [UndergroundDialogOpen, setUndergroundDialogOpen] = useState(false);
    const [lotTitle, setLotTitle] = useState('no title');
    const [StatusDialogOpen, setStatusDialogOpen] = useState(false);
    const navigate = useNavigate();
    // PostFinishJobAutomation state
    const [postFinishAutomationOpen, setPostFinishAutomationOpen] = useState(false);
    const [postFinishRow, setPostFinishRow] = useState(null);
    const [isUploadingFinishTaskFiles, setIsUploadingFinishTaskFiles] = useState(false);
    const [finishTaskUploadUserName, setFinishTaskUploadUserName] = useState('unknown');
    const [phaseFilesDialogOpen, setPhaseFilesDialogOpen] = useState(false);
    const [selectedPhaseFileOid, setSelectedPhaseFileOid] = useState(null);
    const [selectedPhaseFileLotOid, setSelectedPhaseFileLotOid] = useState(null);
    // NEW: comment edit dialog state
    const [commentDialogOpen, setCommentDialogOpen] = useState(false);
    const [commentDraft, setCommentDraft] = useState(job?.comments || '');
    const [clearWorkerStatusDialogOpen, setClearWorkerStatusDialogOpen] = useState(false);
    // Failed QC dialog state (mirror ActivePhase)
    const [failedQCDialogOpen, setFailedQCDialogOpen] = useState(false);
    const [failedQCComments, setFailedQCComments] = useState('');
    const [failedQCDate, setFailedQCDate] = useState('');
    const [failedQCPhaseRow, setFailedQCPhaseRow] = useState(null);
    const [failedQCTeams, setFailedQCTeams] = useState([]);
    const [failedQCTeamOid, setFailedQCTeamOid] = useState('');
    const [failedQCPoNumber, setFailedQCPoNumber] = useState('');
    const [failedQCCost, setFailedQCCost] = useState('');
    // ref to hold a pending phaseRow while Status dialog is closing
    const pendingFailedQCRef = useRef(null);

    const getNumericPhaseOid = (value) => {
        const num = Number(value);
        return Number.isFinite(num) && num > 0 ? num : null;
    };

    const forceInsertMissingPhaseStatus = async (phaseOid) => {
        const normalizedPhaseOid = getNumericPhaseOid(phaseOid);
        if (!normalizedPhaseOid) return;

        try {
            await CentralCalls.callStoredProcedureWithParams('sp_forceInsertMissingPhaseStatus', { phase_oid: normalizedPhaseOid });
        } catch (forceErr) {
            console.error('Error forcing missing phase_status insert:', forceErr);
        }
    };
    // Fetch employee teams when the Failed QC dialog opens
    useEffect(() => {
        const fetchTeams = async () => {
            if (!failedQCDialogOpen) return;
            try {
                const rows = await CentralCalls.fetchTableData('employee_team', {});
                setFailedQCTeams(rows || []);
            } catch (err) {
                console.error('Error fetching teams', err);
                setFailedQCTeams([]);
            }
        };
        fetchTeams();
    }, [failedQCDialogOpen]);

    useEffect(() => {
        // keep draft in sync when job changes
        setCommentDraft(job?.comments || '');
    }, [job]);

    useEffect(() => {
        const setUserInfo = async () => {
            try {
                const user = await Auth.currentAuthenticatedUser();
                setFinishTaskUploadUserName(user?.attributes?.email || user?.username || 'unknown');
            } catch (error) {
                console.error('Error fetching user info', error);
                setFinishTaskUploadUserName('unknown');
            }
        };

        setUserInfo();
    }, []);

    const uploadFinishTaskFiles = async (phaseStatusRow, filesToUpload) => {
        if (!phaseStatusRow?.phase_oid || !job?.lot_oid || !filesToUpload || filesToUpload.length === 0) {
            return;
        }

        setIsUploadingFinishTaskFiles(true);
        try {
            for (const file of filesToUpload) {
                const formData = new FormData();
                formData.append('file', file);
                formData.append('lot_oid', job.lot_oid);
                formData.append('uploaded_by', finishTaskUploadUserName || 'unknown');

                const response = await fetch('/api/files/upload', {
                    method: 'POST',
                    body: formData,
                });

                if (!response.ok) {
                    const errorData = await response.json().catch(() => ({}));
                    throw new Error(errorData.error || `Upload failed for ${file.name}`);
                }

                const uploadedRow = await response.json();
                if (uploadedRow?.oid) {
                    await CentralCalls.upsertData({ oid: uploadedRow.oid, phase_oid: phaseStatusRow.phase_oid }, 'files', 'update');
                }
            }
        } finally {
            setIsUploadingFinishTaskFiles(false);
        }
    };

    const openCommentDialog = () => {
        setCommentDraft(job?.comments || '');
        setCommentDialogOpen(true);
    };

    const handleCommentCancel = () => {
        setCommentDialogOpen(false);
    };

    const handleCommentSave = async () => {
        try {
            await CentralCalls.upsertData(
                { oid: job.phase_status_oid, comments: commentDraft },
                'phase_status',
                'update'
            );
            setCommentDialogOpen(false);
            setRefresh(date); // triggers reload of the row with fresh comments
        } catch (err) {
            console.error(err);
        }
    };

    const handleClearWorkerStatusConfirm = async () => {
        try {
            await CentralCalls.upsertData(
                { oid: job.phase_status_oid, employee_status: null, comments: null, hours: null },
                'phase_status',
                'update'
            );
            job.employee_status = null;
            job.comments = null;
            job.hours = null;
            setClearWorkerStatusDialogOpen(false);
            setRefresh(date);
        } catch (err) {
            console.error('Error clearing worker status', err);
        }
    };

    const handleOpenPhaseFilesClick = async () => {
        setSelectedPhaseFileOid(job?.phase_oid || null);
        setSelectedPhaseFileLotOid(job?.lot_oid || null);
        setPhaseFilesDialogOpen(true);
    };

    const checkDisplayPhaseFiles = (phaseRow) => {
        const countField = phaseRow?.file_count ?? phaseRow?.files_count ?? phaseRow?.phase_file_count ?? phaseRow?.file_cnt;

        if (typeof countField === 'number') {
            return countField > 0;
        }

        if (typeof countField === 'string' && countField.trim() !== '') {
            const parsed = parseInt(countField, 10);
            return !Number.isNaN(parsed) && parsed > 0;
        }

        return false;
    };

    const hasEmployeeSetStatus = (phaseRow) => {
        const status = phaseRow?.employee_status ?? phaseRow?.employeeStatus ?? '';
        return String(status).trim().length > 0;
    };

    const [{ isOver }, drop] = useDrop({
        accept: [ItemTypes.JOB, ItemTypes.CREW_LIST],
        hover: (item, monitor) => {
            // OPTIONAL: If you want live “highlighting” or any hover-based logic, do it here.
            // Just DON’T call moveJob here if you only want a final drop-based reorder.
        },
        drop: (item, monitor) => {
            if (!ref.current || !item) return;

            if (item.type === ItemTypes.JOB) {
                const dragDate = item.date;
                const dragIndex = item.index;
                const dropDate = date.format('YYYY-MM-DD');
                const dropIndex = index;

                // Only reorder if it's a different spot
                if (dragDate === dropDate && dragIndex === dropIndex) return;

                // Finalize the move on drop
                moveJob(item, dragDate, dragIndex, dropDate, dropIndex);

                // Update item to reflect new index/date
                item.index = dropIndex;
                item.date = dropDate;
            }
            else if (item.type === ItemTypes.CREW_LIST) {
                const crewIndex = item.index;
                const crew = item.crew;
                assignCrewToJob(date.format('YYYY-MM-DD'), index, crewIndex, crew);
            }
        },
        collect: (monitor) => ({
            isOver: monitor.isOver()
        })
    });
    const handleWipLinkClick = async () => {
        const path = '/wip?lot_oid=' + job.lot_oid;
        window.open(path, '_blank');
    };
    // useEffect(() => {
    //     const getLotTitle = async () => {
    //         if (UndergroundDialogOpen) {  // Only run when dialog opens
    //             const title = await CentralCalls.callStoredProcedureWithParams('sp_getLotTitle', { lot_oid: job.lot_oid });
    //             setLotTitle(title.title);
    //         }
    //     };
    //     if (UndergroundDialogOpen) { // Ensure it only runs when opening
    //         getLotTitle();
    //     }
    // }, [UndergroundDialogOpen]);  // Only runs when StatusDialogOpen changes
    // useEffect(() => {
    //     const getLotTitle = async () => {
    //         const title = await CentralCalls.callStoredProcedureWithParams('sp_getLotTitle', { lot_oid: job.lot_oid });
    //         setLotTitle(title.title);

    //     };
    //     getLotTitle();
    // }, []);
    const [{ isDragging }, drag] = useDrag({
        type: ItemTypes.JOB,
        item: {
            phase_oid: job.phase_oid,
            phase_status_oid: job.phase_status_oid,
            job,
            index,
            date: date.format('YYYY-MM-DD'),
            type: ItemTypes.JOB
        },
        collect: (monitor) => ({
            isDragging: monitor.isDragging()
        })
    });

    drag(drop(ref));

    const opacity = isDragging ? 0.5 : 1;
    // Get employee names
    // const employeeNames = employees
    //     .filter(emp => job.employee_oids && job.employee_oids.includes(emp.oid))
    //     .map(emp => emp.name);
    const handleCompletephaseClose = async (phaseStatusRow, selectedFiles = []) => {
        setStatusDialogOpen(false);
        console.log('handling phase close...', phaseStatusRow);
        console.log(phaseStatusRow);

        if (selectedFiles.length > 0) {
            try {
                await uploadFinishTaskFiles(phaseStatusRow, selectedFiles);
            } catch (uploadErr) {
                console.error('Error uploading finish task files', uploadErr);
                alert(uploadErr?.message || 'Task completed, but one or more files failed to upload.');
            }
        }
        
        // Trigger PostFinishJobAutomation - it will handle routing internally
        setPostFinishRow(phaseStatusRow);
        setPostFinishAutomationOpen(true);
    };

    // Callback when PostFinishJobAutomation completes
    const handlePostFinishAutomationComplete = async () => {
        setPostFinishAutomationOpen(false);
        setPostFinishRow(null);
        setRefresh(date);
    };
    const handleSavePhaseSaveEdit = async (phaseRow) => { }
    // Open dialog to collect comments/date/team before creating punch phase
    const failedQCAutoPunch = async (phaseRow) => {
        setFailedQCPhaseRow(phaseRow);
        setFailedQCComments(phaseRow.comments || '');
        const dateVal = CentralCalls.normalizeDateOnly(phaseRow.date_scheduled) || phaseRow.date_scheduled || '';
        setFailedQCDate(dateVal);
        setFailedQCDialogOpen(true);
    }

    const confirmFailedQCAutoPunch = async () => {
        const phaseRow = failedQCPhaseRow;
        if (!phaseRow) return;
        const punchPhaseType = phaseRow.phase_type.split('_')[0];

        const teamVal = failedQCTeamOid ? parseInt(failedQCTeamOid, 10) : null;
        var newPhase = null;
        try {
            if (teamVal) {
                newPhase = await CentralCalls.upsertData({ lot_oid: phaseRow.lot_oid, phase_type: punchPhaseType, is_punch: 1, punch_comments: failedQCComments, builder_date: failedQCDate, date_scheduled: failedQCDate }, 'phase', 'insert');
                try {
                    await CentralCalls.upsertData({ phase_oid: newPhase.oid, comments: failedQCComments, employee_team_oid: teamVal }, 'phase_status', 'insert');
                } catch (phaseStatusErr) {
                    await forceInsertMissingPhaseStatus(newPhase?.oid);
                    throw phaseStatusErr;
                }
            }
            else {
                newPhase = await CentralCalls.upsertData({ lot_oid: phaseRow.lot_oid, phase_type: punchPhaseType, is_punch: 1, punch_comments: failedQCComments, builder_date: failedQCDate }, 'phase', 'insert');
                try {
                    await CentralCalls.upsertData({ phase_oid: newPhase.oid, comments: failedQCComments }, 'phase_status', 'insert');
                } catch (phaseStatusErr) {
                    await forceInsertMissingPhaseStatus(newPhase?.oid);
                    throw phaseStatusErr;
                }
            }

            if (failedQCPoNumber || ((failedQCCost && failedQCCost > 0))) {
                await CentralCalls.upsertData({ phase_oid: newPhase.oid, po_number: failedQCPoNumber, price: failedQCCost ? parseFloat(failedQCCost) : null, phase_type: punchPhaseType, comments: failedQCComments }, 'po', 'insert');
            }

            // close and cleanup
            setFailedQCDialogOpen(false);
            setFailedQCPhaseRow(null);
            setFailedQCComments('');
            setFailedQCDate('');
            setFailedQCTeamOid('');
            setFailedQCTeams([]);
            setFailedQCPoNumber('');
            setFailedQCCost('');
            setRefresh(date);
        } catch (err) {
            console.error('Error in confirmFailedQCAutoPunch:', err);
        }
    }

    const getPhaseStatusIcon = () => {
        if (!job) { return; }
        if (job.ready_status === 'upcoming') {
            // If is_active = 0, return "Upcoming" (Overrides all other conditions)
            return <span style={{ padding: '3px', borderRadius: '10px', backgroundColor: '#FFA000', color: 'white' }}> <Tooltip title='Upcoming' arrow><FontAwesomeIcon icon={faHourglassStart} /></Tooltip></span>;
        }
        else if (job.ready_status === 'hold') {
            // If is_active = 0, return "Upcoming" (Overrides all other conditions)
            return <span style={{ padding: '3px', borderRadius: '10px', backgroundColor: '#FFA000', color: 'white' }}><Tooltip title='On Hold' arrow><FontAwesomeIcon icon={faPauseCircle} /></Tooltip></span>;
        }
        else if (job.ready_status === 'cancel') {
            // If is_active = 0, return "Upcoming" (Overrides all other conditions)
            return <span style={{ padding: '3px', borderRadius: '10px', backgroundColor: '#FFA000', color: 'white' }}><Tooltip title='Cancelled' arrow><FontAwesomeIcon icon={faBan} /></Tooltip></span>;
        }
        else if (job.ready_status === 'open') {
            // If date_scheduled or employee_oids is null AND status = open, return "Open"
            return <span style={{ padding: '3px', borderRadius: '10px', backgroundColor: '#FFA000', color: 'white' }}><Tooltip title='Open' arrow><FontAwesomeIcon icon={faClock} /></Tooltip></span>;
        }
        else if (job.ready_status === 'scheduled') {
            // If date_scheduled is not null AND employee_oids is not null AND status = open, return "Scheduled"
            return <span style={{ padding: '3px', borderRadius: '10px', backgroundColor: '#FFA000', color: 'white' }}><Tooltip title='Scheduled' arrow><FontAwesomeIcon icon={faCalendarCheck} /></Tooltip></span>;
        }
        return <Label>NOTHING</Label>
    };
    const handlePutOnHold = async () => {
        const confirmCancellation = window.confirm("Are you sure you want to put this job on hold?");
        if (confirmCancellation) {
            await CentralCalls.upsertData({ 'oid': job.phase_status_oid, 'status': 'hold', 'status_date': new Date() }, 'phase_status', 'update');
            job.phase_status = 'hold';
            setRefresh(date);
            //setRefresh(new Date().getTime());
        }
    }

    const handleRemoveOnHold = async () => {
        const confirmCancellation = window.confirm("Are you sure you want to set back to active?");
        if (confirmCancellation) {
            await CentralCalls.upsertData({ 'oid': job.phase_status_oid, 'status': 'open' }, 'phase_status', 'update');
            //setRefreshKey(!refreshKey);
            //refreshMenu();
        }
    }
    const handleRemoveDeleted = async () => {
        const confirmCancellation = window.confirm("Are you sure you want Revert back to Active?");
        if (confirmCancellation) {
            await CentralCalls.upsertData({ oid: job.phase_status_oid, status: 'open' }, 'phase_status', 'update');
        }
        // refreshMenu();
    }
    const handleDeleteRow = async () => {
        const confirmCancellation = window.confirm("Are you sure you want Delete this Job?");
        if (confirmCancellation) {
            await CentralCalls.upsertData({ oid: job.phase_status_oid, status: 'cancel' }, 'phase_status', 'update');
        }
    }
    const handleSaveUndergroundHistory = async (row) => { }
    const handleDisplayUndergroundApprovalClick = async (row) => {
        //setRefresh(new Date().getTime());
        setUndergroundDialogOpen(true);
        //refreshMenu();
    }

    const handleUnassignCrew = async () => {
        if (typeof unassignCrewFromJob === 'function') {
            unassignCrewFromJob(date.format('YYYY-MM-DD'), index);
            return;
        }

        await CentralCalls.upsertData(
            { oid: job.phase_status_oid, employee_oids: null, employee_team_oid: null },
            'phase_status',
            'update'
        );
        setRefresh(date);
    }
    const handleCompleteUndergroundClose = async (row) => {
        setUndergroundDialogOpen(false);
    }
    const procedureDetailsUndergroundTickets = {
        procedureName: 'ui_getUndergroundTickets',
        parameters: { phase_oid: job.phase_oid, lot_oid: job.lot_oid }
    }
    // const procedureDetailsCompletion = {
    //     procedureName: 'ui_sp_getPhaseCompletionPageData',
    //     parameters: { phase_oid: PhaseOid, lot_oid: LotOid },  // If there are any parameters, define them here as an object
    // };
    // const procedureDetailsCompletionInsert = {
    //     procedureName: 'ui_sp_getPhaseCompletionPageDataInsert',
    //     parameters: { phase_oid: PhaseOid, phase_type: phaseType, lot_oid: LotOid },  // If there are any parameters, define them here as an object
    // };
    const procedureDetailsUndergroundHistory = {
        procedureName: 'ui_sp_wipUndergroundTickets',
        parameters: { lot_oid: job.lot_oid },
    }
    console.log("joBBB..'", job);
    // Avoid UTC parsing shift for date-only values like "YYYY-MM-DD".
    const parseJobDate = (value) => {
        if (!value) return null;
        if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
            const [yyyy, mm, dd] = value.split('-').map(Number);
            return new Date(yyyy, mm - 1, dd);
        }
        return new Date(value);
    };
    const dateObj = parseJobDate(job.date);
    const formattedDate = dateObj
        ? `${String(dateObj.getMonth() + 1).padStart(2, '0')}-${String(dateObj.getDate()).padStart(2, '0')}`
        : '';
    console.log('ogDate', job.date, 'formatteddate:', formattedDate);
    // console.log('droppable jonbs... running')
    return (
        <div
            ref={ref}
            className="droppable-job"
            style={{
                padding: '5px',
                border: '1px solid #ccc',
                borderRadius: '5px',
                opacity,
                backgroundColor: '#f0f0f0',
                transition: 'background-color 0.2s ease, opacity 0.2s ease',
                marginBottom: '0px',
                cursor: 'move',
            }} >

            <div style={{ position: 'relative' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0px' }}>
                    <span style={{ fontSize: '11px' }}>
                        {getPhaseStatusIcon()} | {index + 1} |
                        <Tooltip title="View in WIP" arrow>
                            <IconButton
                                className="recent-lots-button"
                                color="primary"
                                aria-label="save"
                                size="small"
                                onClick={handleWipLinkClick}
                                style={{ padding: '0px' }}>
                                <FontAwesomeIcon
                                    icon={faEye}
                                    style={{ fontSize: '11px' }} />
                            </IconButton>
                        </Tooltip>
                        {job.ready_status === 'scheduled' && (
                            <>
                                | <Tooltip title="Complete Job" arrow>
                                    <IconButton
                                        className="recent-lots-button"
                                        color="primary"
                                        aria-label="save"
                                        size="small"
                                        onClick={() => setStatusDialogOpen(true)}
                                        style={{ padding: '3px' }} >
                                        <FontAwesomeIcon
                                            icon={faCheck}
                                            style={{ fontSize: '11px' }} />
                                    </IconButton>
                                </Tooltip>
                            </>
                        )}
                        {job.ready_status !== 'hold' && (
                            <>|
                                <Tooltip title="Put on Hold" arrow>
                                    <IconButton
                                        className="recent-lots-button"
                                        color="primary"
                                        aria-label="save"
                                        size="small"
                                        onClick={() => handlePutOnHold()}
                                        style={{ padding: '3px' }} >
                                        <FontAwesomeIcon icon={faPause} style={{ fontSize: '11px' }} />
                                    </IconButton>
                                </Tooltip>
                            </>
                        )}
                        {job.ready_status === 'hold' && (
                            <>|
                                <Tooltip title="Set to Active" arrow>
                                    <IconButton
                                        className="recent-lots-button"
                                        color="primary"
                                        aria-label="save"
                                        size="small"
                                        onClick={() => handleRemoveOnHold()}
                                        style={{ padding: '3px' }} >
                                        <FontAwesomeIcon
                                            icon={faPlay}
                                            style={{ fontSize: '11px' }} />
                                    </IconButton>
                                </Tooltip>
                            </>
                        )}
                        {job.ready_status !== 'cancel' && (
                            <>|
                                <Tooltip title="Delete Job" arrow>
                                    <IconButton
                                        className="recent-lots-button"
                                        color="primary"
                                        aria-label="save"
                                        size="small"
                                        onClick={() => handleDeleteRow()}
                                        style={{ padding: '3px' }} >
                                        <FontAwesomeIcon
                                            icon={faTrash}
                                            style={{ fontSize: '11px' }} />
                                    </IconButton>
                                </Tooltip>
                            </>
                        )}
                        {job.ready_status === 'cancel' && (
                            <>|
                                <Tooltip title="Revert to Active" arrow>
                                    <IconButton
                                        className="recent-lots-button"
                                        color="primary"
                                        aria-label="save"
                                        size="small"
                                        onClick={() => handleRemoveDeleted()}
                                        style={{ padding: '3px' }} >
                                        <FontAwesomeIcon
                                            icon={faTrashRestore}
                                            style={{ fontSize: '11px' }} />
                                    </IconButton>
                                </Tooltip>
                            </>
                        )}
                    </span>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                        {job.phase_type_id === 'underground' && (
                            <>
                                <Tooltip title="View Tickets" arrow>
                                    <IconButton
                                        className="recent-lots-button"
                                        color="primary"
                                        aria-label="save"
                                        size="small"
                                        onClick={() => setUndergroundDialogOpen(true)}
                                        style={{ padding: '3px' }} >
                                        <FontAwesomeIcon
                                            icon={faClipboard}
                                            style={{ fontSize: '16px' }} />
                                    </IconButton>
                                </Tooltip>
                            </>
                        )}
                        {job.is_punch === 1 && (
                            <Tooltip title={job.punch_comments || "punch"}>
                                <ReportProblemIcon style={{ fontSize: '16px', color: '#f57c00' }} />
                            </Tooltip>
                        )}
                        {((job.comments && job.comments !== '') || (job.prev_comments && job.prev_comments !== '')) && (
                            <Tooltip
                                title= {
                                    [job.comments && `${job.comments}`, job.prev_comments && `Previous: ${job.prev_comments}`]
                                        .filter(Boolean)
                                        .join(' | ')
                                }
                                arrow
                            >
                                <IconButton
                                    size="small"
                                    onClick={openCommentDialog}
                                    style={{ padding: 0 }}
                                    aria-label="Edit comment"
                                >
                                    <FontAwesomeIcon
                                        icon={faStickyNote}
                                        style={{ fontSize: '15px', color: '#FFA500' }} // Orange note
                                    />
                                </IconButton>
                            </Tooltip>
                        )}

                        {hasEmployeeSetStatus(job) && (
                            <Tooltip title={`Ready for Review${job?.employee_status ? `: ${String(job.employee_status).toLowerCase() === 'fail' ? 'Not Complete' : job.employee_status}` : ''}`} arrow>
                                <IconButton
                                    size="small"
                                    onClick={() => setClearWorkerStatusDialogOpen(true)}
                                    style={{ padding: 0 }}
                                    aria-label="Clear worker status"
                                >
                                    <FactCheckIcon style={{ fontSize: '16px', color: '#2E7D32' }} />
                                </IconButton>
                            </Tooltip>
                        )}

                        {checkDisplayPhaseFiles(job) && (
                            <Tooltip title="View Files" arrow>
                                <IconButton
                                    size="small"
                                    onClick={handleOpenPhaseFilesClick}
                                    style={{ padding: 0 }}
                                    aria-label="View files"
                                >
                                    <FontAwesomeIcon
                                        icon={faFileLines}
                                        style={{ fontSize: '15px', color: '#0B426B' }}
                                    />
                                </IconButton>
                            </Tooltip>
                        )}

                        <Chip
                            style={{
                                fontSize: '11px',
                                height: '18px',
                                lineHeight: '1',
                                padding: '2px 6px',
                                backgroundColor: '#0B426B',
                                color: 'white',
                                minWidth: '0',
                            }}
                            label={job.phase_type}
                        />

                    </div>

                </div>
                <div style={{
                    marginTop: '3px',
                    borderTop: '2px solid #ccc',
                    backgroundColor: job?.employee_oids?.length > 0 ? job.team_color_code : '#f0f0f0',
                    fontSize: '11px',
                    textAlign: 'left',
                    display: 'flex',   // Use flex to align items horizontally
                    flexWrap: 'wrap',
                    gap: '5px',
                    alignItems: 'center' // Align vertically in center
                }}>
                    {/* Left-aligned content */}
                    <div style={{ display: 'flex', gap: '5px', flexWrap: 'wrap', wordBreak: 'break-word', minWidth: '0' }}>
                        <div>{job.builder} |</div>
                        <div>{job.neighborhood} |</div>
                        <div>{job.lot_num}</div>
                        {isPastDue && (<div> | Due:{formattedDate}</div>)}
                        {/* Bring back for completed date */}
                        {job.job_status_date && job.ready_status === 'complete' && (<div> | Completed:{job.job_status_date}</div>)}
                    </div>
                    {/* Right-aligned Chip */}
                    {job.team_oid && (
                        <Chip
                            style={{
                                fontSize: '11px',
                                padding: '5px 4px',
                                marginTop: '5px',
                                minWidth: '0',
                                marginLeft: 'auto'
                            }}
                            key={0}
                            label={` ${job.team_name}`}
                            size="small"
                            onDelete={handleUnassignCrew}
                            deleteIcon={
                                <CloseIcon
                                    style={{ color: 'red', fontSize: '16px', marginTop: '2px' }}
                                />
                            }
                        />)
                    }

                </div>
            </div>

            <FinishTaskDialog
                open={StatusDialogOpen}
                onClose={() => setStatusDialogOpen(false)}
                title={job.title}
                phaseOid={job.phase_oid}
                lotOid={job.lot_oid}
                phaseType={job.phase_type_id}
                onCompletePhaseClose={handleCompletephaseClose}
                onSavePhaseSaveEdit={handleSavePhaseSaveEdit}
                isUploading={isUploadingFinishTaskFiles}
                dialogProps={{
                    TransitionProps: {
                        onExited: () => {
                            if (pendingFailedQCRef.current) {
                                failedQCAutoPunch(pendingFailedQCRef.current);
                                pendingFailedQCRef.current = null;
                            }
                        }
                    }
                }}
            />
            <Dialog fullWidth={true} maxWidth='lg' open={UndergroundDialogOpen} >
                <DialogContent >
                    <>
                        <h2>Tickets</h2>
                        <h4>{job.title}</h4>
                        <JSONTableEditor
                            key={refreshUndergroundKey + 1}
                            procedureDetails={procedureDetailsUndergroundHistory}
                            onSave={handleSaveUndergroundHistory}
                            allowDelete={true}
                            sortOrder={{
                                'oid': 'desc'
                            }} >
                        </JSONTableEditor>
                        <h2>New Ticket
                        </h2>
                        <DynamicForm
                            key={refreshUndergroundKey}
                            procedureDetails={procedureDetailsUndergroundTickets}
                            onSave={handleCompleteUndergroundClose}
                            saveName='Insert'
                            crudType='insert' ></DynamicForm>
                    </>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setUndergroundDialogOpen(false)} color="primary">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog fullWidth maxWidth="sm" open={commentDialogOpen} onClose={handleCommentCancel}>
                <DialogTitle>Edit Comment</DialogTitle>
                <DialogContent>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 12, marginTop: '10px' }}>
                        <TextField
                            label="Comment"
                            value={commentDraft}
                            onChange={(e) => setCommentDraft(e.target.value)}
                            fullWidth
                            multiline
                            minRows={3}
                        />
                        {/* {job?.prev_comments && (
                            <TextField
                                label="Previous Comment"
                                value={job.prev_comments}
                                fullWidth
                                multiline
                                minRows={2}
                                InputProps={{ readOnly: true }}
                            />
                        )} */}
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCommentCancel}>Cancel</Button>
                    <Button variant="contained" onClick={handleCommentSave}>Save</Button>
                </DialogActions>
            </Dialog>

            <Dialog
                fullWidth
                maxWidth="xs"
                open={clearWorkerStatusDialogOpen}
                onClose={() => setClearWorkerStatusDialogOpen(false)}
            >
                <DialogTitle>Clear Worker Status?</DialogTitle>
                <DialogActions>
                    <Button autoFocus onClick={() => setClearWorkerStatusDialogOpen(false)}>No</Button>
                    <Button variant="contained" color="error" onClick={handleClearWorkerStatusConfirm}>Yes</Button>
                </DialogActions>
            </Dialog>

            {/* Failed QC -> create punch confirmation dialog */}
            <Dialog
                fullWidth={true}
                maxWidth='sm'
                open={failedQCDialogOpen}
                onClose={(e, reason) => {
                    // prevent closing via backdrop click or escape key — only OK can close
                    if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
                    setFailedQCDialogOpen(false);
                }}
            >
                <DialogTitle>Failed QC - Create Punch (additional info)</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Provide any comments, a requested date, and assign a team for the auto-created punch phase.
                    </DialogContentText>
                    <TextField
                        margin="normal"
                        label="Comments"
                        multiline
                        minRows={3}
                        fullWidth
                        value={failedQCComments}
                        onChange={(e) => setFailedQCComments(e.target.value)}
                    />
                    <TextField
                        margin="normal"
                        label="Requested Date"
                        type="date"
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                        value={failedQCDate}
                        onChange={(e) => setFailedQCDate(e.target.value)}
                    />
                    <TextField
                        margin="normal"
                        label="Assign Team"
                        select
                        fullWidth
                        value={failedQCTeamOid}
                        onChange={(e) => setFailedQCTeamOid(e.target.value)}
                    >
                        <MenuItem value="">
                            <em>None</em>
                        </MenuItem>
                        {failedQCTeams
                            .slice()
                            .sort((a, b) => (a.name || '').localeCompare(b.name || ''))
                            .map((t) => (
                                <MenuItem key={t.oid} value={t.oid}>{t.name}</MenuItem>
                        ))}
                    </TextField>

                    <div style={{ marginTop: 8, marginBottom: 8 }}>
                        <label style={{ display: 'block', fontWeight: 500 }}>PO</label>
                        <TextField
                            margin="normal"
                            label="PO Number"
                            fullWidth
                            value={failedQCPoNumber}
                            onChange={(e) => setFailedQCPoNumber(e.target.value)}
                        />
                        <TextField
                            margin="normal"
                            label="Cost"
                            type="number"
                            inputProps={{ step: "0.01", min: 0 }}
                            fullWidth
                            value={failedQCCost}
                            onChange={(e) => setFailedQCCost(e.target.value)}
                        />
                    </div>
                </DialogContent>
                <DialogActions>
                    {/* No Cancel — only the OK button proceeds */}
                    <Button onClick={confirmFailedQCAutoPunch} color="primary">OK</Button>
                </DialogActions>
            </Dialog>

            {/* PostFinishJobAutomation component */}
            {postFinishRow && (
                <PostFinishJobAutomation
                    row={postFinishRow}
                    lotOid={job.lot_oid}
                    open={postFinishAutomationOpen}
                    onClose={() => setPostFinishAutomationOpen(false)}
                    onComplete={handlePostFinishAutomationComplete}
                />
            )}

            <WipPhaseFilesDialog
                open={phaseFilesDialogOpen}
                onClose={() => setPhaseFilesDialogOpen(false)}
                phaseOid={selectedPhaseFileOid}
                selectedLotOid={selectedPhaseFileLotOid}
            />

        </div>
    );
}
export default React.memo(DroppableJob);